import * as React from "react";
import { RouteNames } from "./RouteNames";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { TravelSite } from "../sites/TravelSite";
import { AboutMeSite } from "../sites/AboutMeSite";
import { InVisDemoSite } from "../sites/InVisDemoSite";
import { Navbar } from "../ui/Navbar";

export const AppRouter = () => (
  <HashRouter>
    <Navbar />
    <Routes>
      <Route path={RouteNames.ROOT} element={<AboutMeSite />} />
      <Route path={RouteNames.TRAVEL} element={<TravelSite />} />
      <Route path={RouteNames.INVIS_DEMO} element={<InVisDemoSite />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  </HashRouter>
);
